/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export startSpin */
/* harmony export (immutable) */ __webpack_exports__["c"] = createLoader;
/* harmony export (immutable) */ __webpack_exports__["a"] = addCerrar;
/* harmony export (immutable) */ __webpack_exports__["d"] = iniciarForms;
/* unused harmony export traerPolitica */
/* unused harmony export evaluarScrolls */
/* harmony export (immutable) */ __webpack_exports__["i"] = setDefaults;
/* harmony export (immutable) */ __webpack_exports__["g"] = ponerCaptchaModal;
/* unused harmony export afterSubmit */
/* unused harmony export obtenerTerminos */
/* unused harmony export obtenerCaptcha */
/* harmony export (immutable) */ __webpack_exports__["h"] = readURL;
/* harmony export (immutable) */ __webpack_exports__["b"] = addCommas;
/* unused harmony export getScript */
/* unused harmony export jSONInfo */
/* unused harmony export validateUser */
/* harmony export (immutable) */ __webpack_exports__["f"] = obtenerOffsetMenu;
/* unused harmony export espCalendar */
/* harmony export (immutable) */ __webpack_exports__["e"] = obtenerData;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function startSpin(show) {
  var $preload = $('body').find('.preload');

  if ($preload.length) {
    $preload.remove();
  }

  if (show) {
    $('body').append("<div class=\"preload\" style=\"position: fixed;left: 0;bottom: 0;right: 0;top: 0;background-color: rgba(0, 0, 0, 0.7);z-index: 2000;\">\n\t\t\t\t\t\t\t<div style=\"text-align: center; margin: 12rem auto\">\n\t\t\t\t\t\t\t\t<div class=\"preloader-wrapper big active\">\n\t\t\t\t\t\t\t\t\t<div class=\"spinner-layer spinner-white\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"circle-clipper left\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"circle\"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"gap-patch\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"circle\"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"circle-clipper right\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"circle\"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>");
  }
}
function createLoader(show) {
  if (show) {
    if ($('#cubre-page').length == 0) {
      $('body').append('<div id="cubre-page" style="position: fixed;top: 0;left: 0;bottom: 0;right: 0;background-color: rgba(0, 0, 0, .1);z-index: 99999;"></div>');
    }

    $('.capa, .progress').show();
  } else {
    $('.capa, .progress').hide();
    $('#cubre-page').remove();
  }
}
function addCerrar(modal) {
  if ($(modal).attr('data-close') === 'false') return;
  var instances = M.Modal.getInstance(modal),
      $close = $('<button class="btn btn-flat btn-close"><i class="material-icons">close</i></button>');
  $(modal).prepend($close);
  _dataForm = null;
  $close.css({
    position: 'absolute',
    right: '.375rem',
    top: '.375rem'
  });
  $close.on('click', function (event) {
    event.stopPropagation();
    event.preventDefault();
    instances.close();
    $close.remove();

    if (_dataForm !== null) {
      if (_dataForm.status.reload) {
        window.location.reload();
      }
    }
  });
}
function iniciarForms($forms) {
  $forms = $forms == undefined ? $('form:visible') : $forms;

  if ($().datetimepicker != undefined) {
    $.datetimepicker.setLocale('es');
    $forms.each(function () {
      var $dateTime = $(this).find('[data-tipo="date"], [data-tipo="datetime"]');
      $dateTime.each(function (index, element) {
        crearDateTime($(this));
      });
      var $timePicker = $(this).find('[data-tipo="time"]');
      $timePicker.datetimepicker({
        format: 'H:i',
        timepicker: true,
        datepicker: false
      });
    });
  }

  if ($().datetextentry != undefined) {
    $forms.find('.datetextentry').each(function () {
      $(this).datetextentry();
    });
  }

  if ($().chosen != undefined) {
    $forms.find('.chosen').each(function () {
      $(this).chosen({
        width: "100%",
        max_shown_results: 6
      });
    });
  }

  $forms.filter(':visible[data-captcha="true"]').each(function () {
    obtenerCaptcha($(this).attr('id'));
  });
  $forms.filter(':not(.excluir)').find('[data-send="true"]').on('click', function (event) {
    event.stopPropagation();
    event.preventDefault();
    var $este = $(this);
    if ($este.attr('data-disable') == 'true') return false;
    $este.parents('form').submit();
  });
  $forms.filter(':not(.excluir)').each(function (index, data) {
    var $form = $(this);
    $form.find('.politica[data-tdoc]:not(.custom)').each(function (index, data) {
      traerPolitica($(this), {}, $form.find('[data-send]'));
    });
  });
  $forms.filter(':not(.excluir)').each(function (index, data) {
    var $form = $(this),
        obj = {
      onfocusout: function onfocusout(element) {
        $(element).valid();
      },
      invalidHandler: function invalidHandler(event, validator) {
        console.log(event, validator);
        M.toast({
          html: 'Revisa los campos obligatorios'
        });
      },
      submitHandler: function submitHandler(form) {
        //console.log('submitHandler', form);		
        var $btn = $(form).find('[data-send]');
        $.ajax({
          url: $(form).attr('action'),
          type: 'POST',
          data: new FormData(form),
          processData: false,
          contentType: false,
          dataType: 'json',
          beforeSend: function beforeSend() {
            $btn.attr('data-disable', 'true');
            createLoader(true);
          },
          success: function success(data) {
            createLoader(false);
            _dataForm = data;
            afterSubmit(data, $(form), $btn);
          },
          error: function error(xhr, status) {
            console.log(xhr.responseText);
            M.toast({
              html: 'Ocurrió un error inesperado. Intenta nuevamente más tarde'
            });
            createLoader(false);
            $btn.attr('data-disable', 'false');
          }
        });
      },
      success: function success(label, element) {}
    };

    if ($form.attr('data-password') == 'true') {
      obj.rules = {
        password: {
          required: true,
          minlength: 6
        },
        password_confirm: {
          required: true,
          minlength: 5,
          equalTo: "#change_password"
        }
      };
    }

    $form.validate(obj);
  });
  M.updateTextFields();
}
function traerPolitica($politica) {
  var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $boton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  $politica.each(function () {
    var $esto = $(this),
        $info = $esto.find('.info'),
        $checkbox = $esto.find('.checkboxes [type="checkbox"].checkbox'),
        tdoc = $esto.data('tdoc'),
        changes = $esto.hasClass('changes');
    $esto.find('.boton-ver').remove();
    extraData.tipo = tdoc;
    obtenerTerminos(extraData, function (info) {
      if (info === false) {
        M.toast({
          html: 'Ocurrió un error inesperado. Intenta nuevamente más tarde'
        });
      } else {
        // console.log(info[ix].code)
        var ix = Object.keys(info)[0];
        $info.html('<div class="c-info" style="display:none">' + info[ix].documento + '</div>');
        $checkbox.val(info[ix].code);

        if (changes) {
          $esto.find('legend').text(info[ix].titulo);
        }

        setTimeout(function () {
          var width = $info.outerWidth();
          $info.css({
            width: width + 'px',
            'margin-bottom': '.75rem'
          });
          $info.find('.c-info').fadeIn('fast');
          $("<div class=\"center-align boton-ver\"><a href=\"".concat(_ULANG + _URI.ver, "/?code=").concat(info[ix].code, "\" target=\"_blank\" class=\"waves-effect waves-light btn-small verde-full\"><i class=\"material-icons left\">remove_red_eye</i>", 'Ver documento', "</a></div>")).insertBefore($esto.find('.checkboxes'));
          evaluarScrolls($info, $checkbox, $boton);
        }, 500);
      }
    });
  });
}
function evaluarScrolls($infoScroll, $checkbox) {
  var $boton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var porcentaje = ($infoScroll.scrollTop() + $infoScroll.innerHeight()) / $infoScroll[0].scrollHeight * 100;

  if (porcentaje >= 95) {
    $checkbox.prop('readonly', false);

    if ($boton != undefined) {
      checkTerms($checkbox, $boton);
    }

    return;
  }

  $checkbox.prop('readonly', true);
  $checkbox.attr('data-terms', 'true');

  if ($boton !== undefined) {
    $boton.prop('disabled', true).attr('data-disable', true);
  }

  $checkbox.prop('checked', false);
  $checkbox.off('click');
  $checkbox.on('click', function (event) {
    if ($(this).prop('readonly')) {
      M.toast({
        html: 'Antes de chequear esta casilla, debes leer el documento'
      });
      return false;
    }
  });
  $infoScroll.on('scroll', function (event) {
    var porcentaje = ($(this).scrollTop() + $(this).innerHeight()) / $(this)[0].scrollHeight * 100;

    if (porcentaje >= 95) {
      $checkbox.prop('readonly', false);

      if ($boton != undefined) {
        checkTerms($checkbox, $boton);
      }

      $(this).off('scroll');
    }
  });
}

function checkTerms($checkbox, $boton) {
  $checkbox.on('change', function (event) {
    var $form = $(this).parents('form'),
        $checkboxes = $form.find('[data-terms="true"]:not(:checked)');
    $boton.prop('disabled', $checkboxes.length != 0).attr('data-disable', $checkboxes.length != 0 ? 'true' : 'false');
  });
}

function setDefaults() {
  if ($.validator != undefined) {
    jQuery.extend(jQuery.validator.messages, {
      required: "Este campo es obligatorio.",
      remote: "Por favor, rellena este campo.",
      email: "Por favor, escribe una dirección de correo válida",
      url: "Por favor, escribe una URL válida.",
      date: "Por favor, escribe una fecha válida.",
      dateISO: "Por favor, escribe una fecha (ISO) válida.",
      number: "Por favor, escribe un número entero válido.",
      digits: "Por favor, escribe sólo dígitos.",
      creditcard: "Por favor, escribe un número de tarjeta válido.",
      equalTo: "Por favor, escribe el mismo valor de nuevo.",
      accept: "Por favor, escribe un valor con una extensión aceptada.",
      maxlength: jQuery.validator.format("Por favor, no escribas más de {0} caracteres."),
      minlength: jQuery.validator.format("Por favor, no escribas menos de {0} caracteres."),
      rangelength: jQuery.validator.format("Por favor, escribe un valor entre {0} y {1} caracteres."),
      range: jQuery.validator.format("Por favor, escribe un valor entre {0} y {1}."),
      max: jQuery.validator.format("Por favor, escribe un valor menor o igual a {0}."),
      min: jQuery.validator.format("Por favor, escribe un valor mayor o igual a {0}.")
    });
    $.validator.setDefaults({
      errorClass: 'invalid',
      validClass: "valid",
      errorPlacement: function errorPlacement(error, element) {
        var $form = element.closest("form") // ,	$label 	= $form.find("label[for='" + element.attr('id') + "']")
        ,
            isCheck = element.attr('type') == 'checkbox' || element.attr('type') == 'radio',
            $el = $form.find("label[for='" + element.attr('id') + "']");

        if (isCheck) {
          $el = element.parents('label').first();
        } else if (element.attr('type') == 'file') {
          $el = element.parents('.file-field').find('.file-path');
        } else if (element.hasClass('browser-default')) {
          $el = element;
        }

        if (error.text() == '') {
          $el.next('.helper-text').remove();
        } else {
          var $span = $el.next('.helper-text');

          if ($span.length == 0) {
            $('<span class="helper-text" data-error="' + error.text() + '">' + error.text() + '</span>').insertAfter($el);
          } else {
            //$span.attr('data-error', error.text())
            $span.text(error.text());
          }
        }
      }
    });
  }
}
function ponerCaptchaModal($modal) {
  $modal.find('form[data-captcha="true"]').each(function () {
    obtenerCaptcha($(this).attr('id'));
  });
}
function afterSubmit(data) {
  var $form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var $boton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  var status = data.status,
      callback = function callback(status) {
    if (status.go_to != '') {
      window.location.href = status.go_to;
      return true;
    }

    if (status.close) {
      var $modal = $form.parents('.modal');

      if ($modal.length != 0) {
        var instance = M.Modal.getInstance($modal.get(0));
        instance.close();
      }
    }

    if (status.reload) {
      window.location.reload();
      return true;
    }
  };

  if (status.reset && $form != undefined && !status.error) {
    $form.get(0).reset();
  }

  if (status.captcha) {
    obtenerCaptcha($form.attr('id'));
  }

  M.updateTextFields();

  if (_typeof(data.consola) === 'object') {
    console.log(data.consola);
  }

  if (status.localstorage) {
    for (var keys in status.localstorage) {
      window.localStorage.setItem(keys, JSON.stringify(status.localstorage[keys]));
    }
  }

  if (data.messages.length != 0) {
    afterSubmitToast(data.messages, function () {
      callback(status);
    });
  } else {
    callback(status);
  }

  if (typeof $boton !== 'undefined') {
    $boton.attr('data-disable', 'false');
  }

  if (status.functions.length != 0) {
    for (var k in status.functions) {
      if (typeof window[status.functions[k]] === 'function') {
        window[status.functions[k]](data);
      }
    }
  }
}

function afterSubmitToast(messages) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if (messages.length == 0) {
    if (typeof callback === 'function') {
      callback();
    }
  } else {
    var messages_str = '<div>' + messages.join('<br />') + '</div>' + "<button class=\"btn-flat toast-action\" onClick='M.Toast.getInstance(this.parentElement).dismiss();'>Cerrar</button>";
    M.toast({
      html: messages_str,
      displayLength: 6000,
      completeCallback: callback
    });
  }
}

function obtenerTerminos(data, callback) {
  $.ajax({
    type: "POST",
    url: '/action/terminos/',
    data: data,
    dataType: 'json',
    beforeSend: function beforeSend() {
      createLoader(true);
    },
    success: function success(data) {
      createLoader(false);

      if (data.ans.transaction == 'OK') {
        callback(data.ans.documents);
      } else {
        callback(false);
      }
    }
  });
}
function obtenerCaptcha(formId) {
  if (!_CAPTCHA) return false;
  var $form = $('#' + formId),
      $btn = $form.find('[data-send="true"]');
  $btn.addClass('disabled').attr('data-disable', 'true');
  grecaptcha.ready(function () {
    grecaptcha.execute(_CAPTCHA_WEBS, {
      action: $form.attr('action')
    }).then(function (token) {
      var $input = $form.find('[name="g-recaptcha-response"]');
      if ($input.length == 0) $input = $('<input type="hidden" name="g-recaptcha-response" />').appendTo($form);
      $input.val(token);
      $btn.removeClass('disabled').attr('data-disable', 'false');
    });
  });
}
function readURL(input, $img) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();

    reader.onload = function (e) {
      $img.attr('src', e.target.result);
    };

    reader.readAsDataURL(input.files[0]);
  } else {
    $(input).parents('.file-field').find('.file-path').text('');
    $img.attr('src', $img.attr('data-src'));
  }
} // Mejorar números

function addCommas(nStr) {
  nStr += '';
  var x = nStr.split('.'),
      x1 = x[0],
      x2 = x.length > 1 ? ',' + x[1] : '',
      rgx = /(\d+)(\d{3})/;

  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + '.' + '$2');
  }

  return x1 + x2;
}
function getScript(url, success) {
  var script = document.createElement('script');
  script.src = url;
  var head = document.getElementsByTagName('head')[0],
      done = false;

  script.onload = script.onreadystatechange = function () {
    if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) {
      done = true;
      script.onload = script.onreadystatechange = null;
      head.removeChild(script);
      if (typeof success == 'function') success();
    }
  };

  try {
    head.appendChild(script);
  } catch (err) {
    console.log(err.message);
  }
}
function jSONInfo(config, option, callBack) {
  var cnfAjax = {
    url: config.action,
    type: config.type,
    data: option,
    dataType: "json",
    success: function success(data) {
      if (typeof callBack == 'function') callBack(data);
    },
    error: function error(jqXHR, textStatus, errorThrown) {
      console.log("jSONInfo - No se pudo cargar la pagina: ", jqXHR.responseText, errorThrown);
    }
  },
      $files = config.Files;
  $.ajax(cnfAjax).fail(function (jqXHR, textStatus, errorThrown) {
    console.log("jSONInfo - No se pudo cargar la pagina: ", jqXHR.responseText, errorThrown);
  });
}
function validateUser() {
  return validate;
}
function obtenerOffsetMenu(element) {
  if (element == undefined) return;
  var invisibleItems = [];

  for (var i = 0; i < element.childElementCount; i++) {
    if (element.children[i].offsetTop + element.children[i].offsetHeight > element.offsetTop + element.offsetHeight || element.children[i].offsetLeft + element.children[i].offsetWidth > element.offsetLeft + element.offsetWidth) {
      invisibleItems.push(element.children[i]);
    }
  }

  return invisibleItems;
}
function espCalendar() {
  return {
    cancel: 'Cerrar',
    clear: 'Limpiar',
    done: 'Aceptar',
    previousMonth: '‹',
    nextMonth: '›',
    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    weekdays: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'],
    weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sáb'],
    weekdaysAbbrev: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };
}
function obtenerData(slugVista, keyVista, callback) {
  $.ajax({
    type: "POST",
    url: '/action/data-vista/',
    data: {
      slugVista: slugVista,
      keyVista: keyVista
    },
    dataType: 'json',
    beforeSend: function beforeSend() {
      createLoader(true);
    },
    success: function success(data) {
      createLoader(false);
      callback(data.ans);
    }
  });
}

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_utils_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_vista_styl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stylus_vista_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stylus_vista_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_fontawesome_css_brands_min_css__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_fontawesome_css_brands_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__libs_fontawesome_css_brands_min_css__);
 //Materialize

 //FontAwsome


var itemAnim = null,
    timerRev = null,
    map = null,
    _loaded = false,
    dataJS = null,
    esAnim = null,
    tipoVista = null,
    initAnim = 0,
    cantAnim = null,
    centerMap = null;
$(document).ready(function () {
  // 
  Object(__WEBPACK_IMPORTED_MODULE_0__js_utils_js__["e" /* obtenerData */])(slugVista, keyVista, function (data) {
    if (data.status !== true) {
      M.toast({
        html: 'Ocurrió un error durante la recuperación de la información'
      });
      return;
    }

    console.log(data);
    esAnim = data.vista.esAnim == 1;
    tipoVista = data.vista.tipoVista;

    switch (tipoVista) {
      // Mapa de calor
      case '2':
        pintarMapa(data.cantAnim, data.dataJS, data.center);
        break;
      // Gráfico de barras
      // Gráfico de línea
      // Gráfico de radar
      // Gráfico de torta
      // Gráfico polar
      // Gráfico de rosquilla

      case '4':
      case '5':
      case '7':
      case '6':
      case '8':
      case '9':
        var chartData = {
          labels: data.dataJS[0].labels,
          datasets: data.dataJS[0].datasets
        },
            chartConfig = {
          type: data.vista.tiposVistaHomolog,
          data: chartData,
          options: {
            elements: {
              bar: {
                borderWidth: 2
              }
            },
            responsive: true,
            plugins: {
              legend: {
                position: 'top'
              },
              title: {
                display: true,
                text: data.vista.nameVista
              }
            }
          }
        },
            $canvas = $('#chart-data canvas'),
            ctx = $canvas.get(0).getContext("2d"),
            myChart = new Chart(ctx, chartConfig);
        break;

      default:
        console.log(data.data);
        $('#table-data').empty();
        pintarTabla($('#table-data'), data.data[0].headers, data.data[0].data);
    }
  });
  $('#ctl_play').on('click', function (event) {
    event.stopPropagation();
    event.preventDefault();
    iniciarAnimacion();
  });
  $('#ctl_stop').on('click', function (event) {
    event.stopPropagation();
    event.preventDefault();
    stopAnimacion();
  });
  $('#ctl_rages').on('mouseup', function (event) {
    itemAnim = $(this).val();
  });
});

function iniciarAnimacion() {
  if (timerRev != null) return;
  $('#ctl_play').addClass('pressed');
  itemAnim = initAnim;
  timerRev = setInterval(function () {
    if (!_loaded) return;

    if (itemAnim >= cantAnim || dataJS[itemAnim + 1] == undefined) {
      stopAnimacion();
      return;
    }

    itemAnim = itemAnim + 1;
    $('#ctl_rages').val(itemAnim);
    $('.controllers .label').text(dataJS[itemAnim].label);
    map.getSource('custom-points').setData(dataJS[itemAnim].markers); // map.panTo(dataJS[itemAnim].center);
  }, 200);
}

function stopAnimacion() {
  if (timerRev == null) return;
  $('#ctl_play').removeClass('pressed');
  clearInterval(timerRev);
  timerRev = null;
  itemAnim = initAnim;
}

function pintarTabla($where, header, data) {
  var $table = $('<table />').appendTo($where),
      $thead = $('<thead />').appendTo($table),
      $tbody = $('<tbody />').appendTo($table);
  var $trHead = $('<tr />').appendTo($thead);

  for (var i in header) {
    $trHead.append("<th>".concat(header[i], "</th>"));
  }

  for (var fila in data) {
    var $trFila = $('<tr />').appendTo($tbody);

    for (var columna in data[fila]) {
      $trFila.append("<td>".concat(data[fila][columna], "</td>"));
    }
  }
}

function pintarMapa(setCantAnim, setDataJS, setCenterMap) {
  if ($('#map').length == 0) return;
  if ($('#map.iniciado').length == 1) return;
  cantAnim = setCantAnim;
  dataJS = setDataJS;
  centerMap = setCenterMap;
  var elements = $('#bigheader').outerHeight(true) + $('#bigbreadcrumbs').outerHeight(true) + $('#bigfooter').outerHeight(true) + $('#bigcontainer').outerHeight(true),
      realHeight = $(window).outerHeight(true) - elements;
  $('#map').height(realHeight);
  $('#map').addClass('iniciado');
  $('#ctl_rages').attr({
    min: initAnim,
    max: cantAnim
  }).val(0);
  $('.controllers').css('display', esAnim ? 'flex' : 'none');
  mapboxgl.accessToken = 'pk.eyJ1Ijoic3J1ZWRhIiwiYSI6ImNsNnV3cjhneDBuZTMzZHA1NmloYWZzbGIifQ.UnmbWc-FJbmwlgfFDg7BKw';
  map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/streets-v11',
    center: centerMap,
    zoom: esAnim ? 12 : 13
  });
  map.on('load', function () {
    map.addSource('custom-points', {
      'type': 'geojson',
      'data': dataJS[0].markers
    });
    map.addLayer({
      'id': 'trees-heat',
      'type': 'heatmap',
      'source': 'custom-points',
      'maxzoom': 15,
      'paint': {
        // increase weight as diameter breast height increases
        'heatmap-weight': {
          'property': 'value',
          'type': 'exponential',
          'stops': [[1, 0], [100, 1]]
        },
        // increase intensity as zoom level increases
        'heatmap-intensity': {
          'stops': [[11, 1], [15, 3]]
        },
        // use sequential color palette to use exponentially as the weight increases
        'heatmap-color': ['interpolate', ['linear'], ['heatmap-density'], 0, 'rgba(16, 52, 166, 0)', 0.2, 'rgba(26,255,26,.8)', 0.4, 'rgba(234,255,0,.8)', 0.6, 'rgba(255,191,0,.8)', 0.8, 'rgba(255, 64, 0,.8)', 0.9, 'rgba(246,45,45,.9)'],
        // increase radius as zoom increases
        'heatmap-radius': {
          'stops': [[11, 15], [15, 20]]
        },
        // decrease opacity to transition into the circle layer
        'heatmap-opacity': {
          'default': .9,
          'stops': [[14, .9], [15, 0]]
        }
      }
    }, 'waterway-label');
    map.addLayer({
      'id': 'circle-dots-sr',
      'type': 'circle',
      'source': 'custom-points',
      'minzoom': 14,
      'paint': {
        // increase the radius of the circle as the zoom level and value value increases
        'circle-radius': {
          'property': 'value',
          'type': 'exponential',
          'stops': [[{
            zoom: 15,
            value: 0
          }, 5], [{
            zoom: 15,
            value: 100
          }, 10], [{
            zoom: 22,
            value: 0
          }, 20], [{
            zoom: 22,
            value: 100
          }, 50]]
        },
        'circle-color': {
          'property': 'value',
          'type': 'exponential',
          'stops': [[5, 'rgba(26,255,26,.9)'], [25, 'rgba(234,255,0,.9)'], [55, 'rgba(255,191,0,.9)'], [75, 'rgba(255, 64, 0,.9)'], [95, 'rgba(246,45,45,.9)']]
        },
        'circle-stroke-color': 'white',
        'circle-stroke-width': 0,
        'circle-opacity': {
          'stops': [[10, 0], [14, 1]]
        }
      }
    }, 'waterway-label');
    _loaded = true;
  }); // click on tree to view dbh in a popup

  map.on('click', 'circle-dots-sr', function (event) {
    new mapboxgl.Popup().setLngLat(event.features[0].geometry.coordinates).setHTML("<strong>".concat(event.features[0].properties.yTag, ":</strong> ").concat(Object(__WEBPACK_IMPORTED_MODULE_0__js_utils_js__["b" /* addCommas */])(Math.round(event.features[0].properties.vTag)))).addTo(map);
  });
}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// vista.bundle.js